import {NgModule} from '@angular/core'
import {CommonModule} from '@angular/common'
import {DirectAccessFilterComponent} from './direct-access-filter.component'
import {SharedModule} from '../shared/shared.module'
import {RouterModule} from '@angular/router'


@NgModule({
  declarations: [DirectAccessFilterComponent],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule
  ],
  exports: [DirectAccessFilterComponent],
})
export class DirectAccessFilterModule {
}
